import script from "./SharedBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedBanner.vue?vue&type=script&setup=true&lang=ts"

import "./SharedBanner.vue?vue&type=style&index=0&id=663b612e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-663b612e"]])

export default __exports__